import type { FC, ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

interface CustomLogoBoxProps {
    children: ReactNode;
}

// apparently ChakraUI doesn't support linear gradients out of the box, and this is the most common way to do it

export const CustomLogoBox: FC<CustomLogoBoxProps> = ({ children }) => (
    <Box
        display="flex"
        width="40px"
        height="40px"
        p="1px"
        borderRadius="8px"
        bg="linear-gradient(19deg, #8246E0 12.57%, #E44185 47.54%, #FF7806 100%)"
        aspectRatio="1/1"
    >
        <Box
            display="flex"
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            gap="10px"
            borderRadius="inherit"
            bg="white"
        >
            {children}
        </Box>
    </Box>
);
